import { RowCellContent, Table, TableBody, TableHeadColumn } from "@dash/table";

import { UserWorkTimeReport } from "@megaron/crm-contracts";

import { formatWorkTime } from "./WorkTimeDialog";

type Props = {
  report: UserWorkTimeReport;
  isLoading?: boolean;
};

export const WorkTimeReportTable = ({ report, isLoading = false }: Props) => {
  const tableColumns: TableHeadColumn<"">[] = [
    ...tableHeadingsList.map(
      ({ heading }) =>
        ({
          isSortable: false,
          label: heading,
        } as const),
    ),
  ];

  const getTableRowCellsContent = (reportDay: UserWorkTimeReport["days"][number]): RowCellContent[] => [
    {
      cellCss: { minWidth: "6rem" },
      element: reportDay.date,
    },
    {
      element: reportDay.startTime ? formatTime(reportDay.startTime) : "-",
    },
    {
      element: reportDay.endTime ? formatTime(reportDay.endTime) : "-",
    },
    {
      element: formatWorkTime(reportDay.breakDurationMinutes),
    },
    {
      cellCss: { minWidth: "10rem" },
      element: formatWorkTime(reportDay.workTimeMinutes ?? 0),
    },
    {
      element: reportDay.posVisitCount,
    },
    {
      element: reportDay.visitCount,
    },
    {
      element: reportDay.interactionCount,
    },
    {
      element: reportDay.email,
    },
  ];

  return (
    <div css={{ overflow: "auto", margin: "0 -2rem 1rem" }}>
      <Table<""> columns={tableColumns} css={{ padding: "0 2rem" }}>
        <TableBody
          isLoading={isLoading}
          rows={report.days.map((day) => ({
            uuid: day.date,
            linkTo: `/crm/regions/region/${day.date}`,
            cellsContent: getTableRowCellsContent(day),
            css: {
              "td:first-child": {
                padding: "0.75rem",
              },
              "&:hover": {
                "td:first-child": {
                  textDecoration: "underline",
                },
              },
            },
          }))}
        />
      </Table>
    </div>
  );
};

export const tableHeadingsList: { heading: string }[] = [
  { heading: "Data" },
  { heading: "Początek" },
  { heading: "Koniec" },
  { heading: "Przerwy" },
  { heading: "Czas pracy" },
  { heading: "Liczba wizyt POS" },
  { heading: "Liczba wizyt" },
  { heading: "Liczba interakcji" },
  { heading: "Email" },
];

const formatTime = (date: Date) =>
  date.toLocaleTimeString(undefined, {
    hour: "numeric",
    minute: "2-digit",
  });
